import '../styles/blue-btn.css'

export default function BlueBtn({width,text}) {
  return (
    <a className='blue-btn' style={{width:`${width}px`}} href='/'>
        {text}
    </a>
  )
}
